import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=545b733e"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports